import React, {useState, useEffect, useRef, useMemo} from 'react';
import {Tabs} from '@ey/canvascoreservices';
import {
	extendedPagingOptions,
	controlDesignEffectivenessLables,
	booleanControlLabel,
	ToastMessageVariants,
	toastMessageDisplayDuration
} from '../../../util/uiconstants';
import Button from '../BaseComponentWrappers/MotifButton';
import ProgressBar from '../BaseComponentWrappers/MotifProgressBar';
import Utility from '../../../util/utilityfunctions';
import Pagination from '../../Common/Pagination/Pagination';
import styled from 'styled-components';
import AgGridWrapper from '../BaseComponentWrappers/AgGridWrapper';
import {labels, isNullOrUndefined} from '../../../util/utils';
import EllipsesControl from '../EllipsesControl/EllipsesControl';
import RelateFlowchartWCGWModal from './RelateFlowchartWCGWModal';
import {
	unrelateWCGWFromFlowChartStep,
	updateStoreUnrelatedWCGWFromFlowchartStep,
	unrelateControlFromFlowChartStep,
	updateStoreUnrelatedControlFromFlowchartStep,
	unrelateItApplicationFromFlowChartStep,
	updateStoreUnrelatedITApplicationFromFlowchartStep
} from '../../../actions/FlowChart/flowchartstepactions';
import {useDispatch, useSelector} from 'react-redux';
import {useEngagementId} from '../../../util/customHooks';
import MotifTableRemoveCellRenderer from '../BaseComponentWrappers/MotifTableRemoveCellRenderer';
import RelateFlowchartControlModel from './RelateFlowchartControlModel';
import Loader from '../LoadingIndicator/LoadingIndicator';
import {setFormV2ToasterVisibility} from '../../../actions/toastactions';
import RelateFlowchartITAppSOModal from './RelateFlowchartITAppSOModal';

const StepTabSection = (props) => {
	const {
		activeTab,
		tabs,
		onTabChange,
		stepTabRelateButtonLabel,
		stepsTabTableList,
		noRowDataLabel,
		relateButtonLabel,
		validateFormData,
		createStep,
		draftFlowchartStepId,
		setIsCalledFromFooterControl,
		fetchFlowChartStepById,
		stepName
	} = props;

	const dispatch = useDispatch();

	const flowchartId = useSelector((state) => state.flowChart.data[0].id);
	const flowchartStepId = useSelector((state) => state.flowchartStep.id);
	const engagementId = useEngagementId();
	const loadingStates = useRef({});

	let gridApi = useRef(null);
	const [paging, setPaging] = useState({
		currentPage: 1,
		pageSize: extendedPagingOptions.options[0],
		totalPages: 1
	});
	const [isLoading, setIsLoading] = useState(true);
	const [isFlowchartStepWCGWModalOpen, setIsFlowchartStepWCGWModalOpen] = useState(false);
	const [isFlowchartStepControlModalOpen, setIsFlowchartStepControlModalOpen] = useState(false);
	const [isFlowchartStepITApplicationSO, setIsFlowchartStepITApplicationSO] = useState({
		isITApplicationModalOpen: false,
		isITSOOpen: false
	});

	useEffect(() => {
		if (draftFlowchartStepId === 0) return;

		fetchFlowChartStepById(draftFlowchartStepId).then(() => {
			openFooterControlModal();
		});
	}, [draftFlowchartStepId]);

	function openFooterControlModal() {
		switch (activeTab) {
			case 1:
				setIsFlowchartStepWCGWModalOpen(!isFlowchartStepWCGWModalOpen);
				break;
			case 2:
				setIsFlowchartStepControlModalOpen(!isFlowchartStepControlModalOpen);
				break;
			case 3:
				setIsFlowchartStepITApplicationSO(() => ({
					isITApplicationModalOpen: !isFlowchartStepITApplicationSO.isITApplicationModalOpen,
					isITSOOpen: false
				}));
				break;
			case 4:
				setIsFlowchartStepITApplicationSO(() => ({
					isITSOOpen: !isFlowchartStepITApplicationSO.isITSOOpen,
					isITApplicationModalOpen: false
				}));
				break;
		}
	}

	function handleButtonClick() {
		if (validateFormData()) {
			if (!isNullOrUndefined(flowchartStepId)) {
				openFooterControlModal();
			} else {
				//Trigger POST call to create new flowchart step on click of footer controls
				setIsCalledFromFooterControl(true);
				createStep(true);
			}
		}
	}

	const buttonConfig = [
		{
			id: 1,
			onClick: () => {
				handleButtonClick();
			}
		},
		{
			id: 2,
			onClick: () => {
				handleButtonClick();
			}
		},
		{
			id: 3,
			onClick: () => {
				handleButtonClick();
			}
		},
		{
			id: 4,
			onClick: () => {
				handleButtonClick();
			}
		}
	];

	const setTabChangeIndex = (tabIndex) => {
		if (tabIndex !== activeTab) {
			setIsLoading(true);
			onTabChange(tabIndex);
		}
	};

	const getStepTabColumnDefinition = useMemo(
		() => (tabIndex) => {
			switch (tabIndex) {
				case 1:
					return [
						{
							headerComponent: ellipsisHeaderComponent,
							headerComponentParams: {
								label: labels.flowChartNewSteps.headerNameForWCGW
							},
							field: 'wcgwName',
							cellRenderer: 'nameCellRenderer',
							flex: 7,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'loader',
							cellRenderer: 'loaderCellRenderer',
							flex: 1,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'remove',
							flex: 3,
							cellRenderer: 'motifTableRemoveCellRenderer',
							cellRendererParams: {
								data: {
									remove: {
										onRemove: (data) => {
											loadingStates.current = {...loadingStates.current, [data.wcgwId]: true};
											gridApi.current.refreshCells({force: true});

											const tempFlowchartStepId = data.flowchartStepId;

											dispatch(
												unrelateWCGWFromFlowChartStep(engagementId, flowchartId, tempFlowchartStepId, data.wcgwId)
											)
												.then(() => {
													dispatch(
														updateStoreUnrelatedWCGWFromFlowchartStep({
															flowchartStepId: tempFlowchartStepId,
															wcgwId: data.wcgwId
														})
													);
												})
												.finally(() => {
													loadingStates.current = {};
													gridApi.current?.refreshCells({force: true});
												});
										}
									}
								}
							},
							suppressMenu: true,
							suppressMovable: true
						}
					];
				case 2:
					return [
						{
							headerComponent: ellipsisHeaderComponent,
							headerComponentParams: {
								label: labels.flowChartNewSteps.headerNameForControl
							},
							field: 'controlName',
							cellRenderer: 'nameCellRenderer',
							flex: 6,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerComponent: ellipsisHeaderComponent,
							headerComponentParams: {
								label: labels.flowChartNewSteps.designEffectiveness
							},
							field: 'controlDesignEffectivenessTypeId',
							valueFormatter: (params) => controlDesignEffectivenessLables[params.value],
							cellRenderer: 'controlDesignEffectivenessCellRenderer',
							flex: 3,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerComponent: ellipsisHeaderComponent,
							headerComponentParams: {
								label: labels.flowChartNewSteps.testing
							},
							field: 'hasControlTesting',
							valueFormatter: (params) => booleanControlLabel[params.value],
							flex: 2,
							cellRenderer: 'controlTestingCellRenderer',
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerComponent: ellipsisHeaderComponent,
							headerComponentParams: {
								label: labels.flowChartNewSteps.lowerRisk
							},
							field: 'isLowerRisk',
							valueFormatter: (params) => booleanControlLabel[params.value],
							cellRenderer: 'controlLowerRiskCellRenderer',
							flex: 2,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'loader',
							cellRenderer: 'loaderCellRenderer',
							flex: 1,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'remove',
							flex: 2,
							cellRenderer: 'motifTableRemoveCellRenderer',
							cellRendererParams: {
								data: {
									remove: {
										onRemove: (data) => {
											loadingStates.current = {...loadingStates.current, [data.controlId]: true};
											gridApi.current.refreshCells({force: true});

											const tempFlowchartStepId = data.flowchartStepId;

											dispatch(
												unrelateControlFromFlowChartStep(engagementId, flowchartId, tempFlowchartStepId, data.controlId)
											)
												.then(() => {
													dispatch(
														updateStoreUnrelatedControlFromFlowchartStep({
															flowchartStepId: tempFlowchartStepId,
															controlId: data.controlId
														})
													);
												})
												.catch((error) => {
													dispatch(
														setFormV2ToasterVisibility(
															true,
															ToastMessageVariants.Error,
															Utility.createRichTextElement(error?.meessage),
															'',
															toastMessageDisplayDuration
														)
													);
												})
												.finally(() => {
													loadingStates.current = {};
													gridApi.current?.refreshCells({force: true});
												});
										}
									}
								}
							},
							suppressMenu: true,
							suppressMovable: true
						}
					];
				case 3:
					return [
						{
							headerComponent: ellipsisHeaderComponent,
							headerComponentParams: {
								label: labels.flowChartNewSteps.headerNameForITApp
							},
							field: 'itApplicationName',
							cellRenderer: 'nameCellRenderer',
							flex: 7,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'loader',
							cellRenderer: 'loaderCellRenderer',
							flex: 1,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'remove',
							flex: 3,
							cellRenderer: 'motifTableRemoveCellRenderer',
							cellRendererParams: {
								data: {
									remove: {
										onRemove: (data) => {
											loadingStates.current = {...loadingStates.current, [data.itApplicationId]: true};
											gridApi.current.refreshCells({force: true});

											const tempFlowchartStepId = data.flowchartStepId;

											dispatch(
												unrelateItApplicationFromFlowChartStep(
													engagementId,
													flowchartId,
													tempFlowchartStepId,
													data.itApplicationId
												)
											)
												.then(() => {
													dispatch(
														updateStoreUnrelatedITApplicationFromFlowchartStep({
															flowchartStepId: tempFlowchartStepId,
															itApplicationId: data.itApplicationId,
															isServiceOrganization: data.isServiceOrganization
														})
													);
												})
												.finally(() => {
													loadingStates.current = {};
													gridApi.current?.refreshCells({force: true});
												});
										}
									}
								}
							},
							suppressMenu: true,
							suppressMovable: true
						}
					];
				case 4:
					return [
						{
							headerComponent: ellipsisHeaderComponent,
							headerComponentParams: {
								label: labels.flowChartNewSteps.headerNameForServiceOrganisation
							},
							field: 'soName',
							cellRenderer: 'nameCellRenderer',
							flex: 7,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'loader',
							cellRenderer: 'loaderCellRenderer',
							flex: 1,
							suppressMenu: true,
							suppressMovable: true
						},
						{
							headerName: '',
							field: 'remove',
							flex: 3,
							cellRenderer: 'motifTableRemoveCellRenderer',
							cellRendererParams: {
								data: {
									remove: {
										onRemove: (data) => {
											loadingStates.current = {...loadingStates.current, [data.itApplicationId]: true};
											gridApi.current.refreshCells({force: true});

											const tempFlowchartStepId = data.flowchartStepId;

											dispatch(
												unrelateItApplicationFromFlowChartStep(
													engagementId,
													flowchartId,
													tempFlowchartStepId,
													data.itApplicationId
												)
											)
												.then(() => {
													dispatch(
														updateStoreUnrelatedITApplicationFromFlowchartStep({
															flowchartStepId: tempFlowchartStepId,
															itApplicationId: data.itApplicationId,
															isServiceOrganization: data.isServiceOrganization
														})
													);
												})
												.finally(() => {
													loadingStates.current = {};
													gridApi.current?.refreshCells({force: true});
												});
										}
									}
								}
							},
							suppressMenu: true,
							suppressMovable: true
						}
					];
			}
		},
		[]
	);

	const updateTotalPages = () => {
		if (Object.keys(stepsTabTableList).length > 0) {
			let totalPages = Math.ceil(stepsTabTableList?.length / paging.pageSize);
			setPaging((prevPaging) => ({...prevPaging, totalPages}));
		}
	};

	useEffect(() => {
		updateTotalPages();
		setIsLoading(false);
	}, [paging.currentPage, paging.pageSize, stepsTabTableList]);

	useEffect(() => {
		setPaging((prevPaging) => ({...prevPaging, currentPage: 1}));
		gridApi?.current?.paginationGoToFirstPage();
	}, [activeTab]);

	const handleGridReady = (params) => {
		gridApi.current = params?.api;
	};

	const handleOnPageSizeChange = (pageSize) => {
		setPaging((prevPaging) => ({...prevPaging, pageSize, currentPage: 1}));
	};

	const handleOnPageChange = (pageNumber) => {
		setPaging((prevPaging) => ({...prevPaging, currentPage: pageNumber}));
		gridApi?.current?.paginationGoToPage(pageNumber - 1);
	};

	const CustomNoRowsOverlay = () => {
		let relateLabelMessage = noRowDataLabel.split('{0}');
		let buttonClick = (
			<Button
				onClick={() => buttonConfig[activeTab - 1]?.onClick()}
				variant="text-alt"
				showLabel
				isEllipsed
				buttonLabel={relateButtonLabel}
				noOfLines={1}
			/>
		);

		return (
			<div className="no-rows-overlay">
				<span>{relateLabelMessage[0]}</span>
				<div className="table-button-click">{buttonClick}</div>
				<span>{relateLabelMessage[1]}</span>
			</div>
		);
	};
	const RemoveCellRendererFramework = (params) => {
		const isLoading = loadingStates.current[params.data.wcgwId || params.data.controlId || params.data.itApplicationId];
		return isLoading ? null : <MotifTableRemoveCellRenderer {...params} />;
	};

	const LoaderCellRenderer = ({data}) => {
		return loadingStates.current[data.wcgwId || data.controlId || data.itApplicationId] ? <Loader show /> : null;
	};

	return (
		<StyledStepTabContainer className="steptabnav">
			<Tabs
				styleName="steptab"
				allowActiveTabClick={true}
				activeTab={activeTab}
				badge
				tabs={tabs || []}
				theme={Utility.getTheme()}
				ellipse
				onTabChange={(tab) => setTabChangeIndex(tab)}
			/>
			<section className="relate-wcgw">
				<Button
					onClick={buttonConfig[activeTab - 1]?.onClick}
					variant="text-alt"
					showLabel
					isEllipsed
					buttonLabel={stepTabRelateButtonLabel}
					noOfLines={1}
				/>
			</section>
			{stepsTabTableList.length !== 0 ? (
				<section className="parentwrapper">
					<section className="AGGridWrapperSection">
						<AgGridWrapper
							loading={isLoading}
							columnDefs={getStepTabColumnDefinition(activeTab)}
							components={{
								motifTableRemoveCellRenderer: RemoveCellRendererFramework,
								nameCellRenderer: NameCellRenderer,
								loaderCellRenderer: LoaderCellRenderer
							}}
							rowData={stepsTabTableList || []}
							onReady={handleGridReady}
							// domLayout="autoHeight"
							suppressRowClickSelection
							suppressCellSelection
							suppressHorizontalScroll
							suppressContextMenu
							suppressCellFocus
							rowBuffer={10}
							rowHeight={40}
							headerHeight={40}
							animateRows
							pagination
							hideOverlay
							paginationPageSizeSelector={extendedPagingOptions.options}
							paginationPageSize={paging.pageSize}
							suppressPaginationPanel
							loadingOverlayComponent={ProgressBar}
							loadingOverlayComponentParams={{
								isIndeterminate: true,
								circle: true
							}}
						/>
					</section>
					<section className="pagination-control">
						<Pagination
							optionsPerPage={extendedPagingOptions.options}
							page={paging.currentPage}
							pageSize={paging.pageSize}
							pageCount={paging.totalPages}
							onPageSizeChanged={handleOnPageSizeChange}
							onPageChanged={handleOnPageChange}
						/>
					</section>
				</section>
			) : (
				<section className="norow">
					<CustomNoRowsOverlay />
				</section>
			)}
			<section>
				{isFlowchartStepWCGWModalOpen && (
					<RelateFlowchartWCGWModal
						isModalOpen={isFlowchartStepWCGWModalOpen}
						onClickRelateModal={buttonConfig[0].onClick}
						stepName={stepName}
					/>
				)}
				{isFlowchartStepControlModalOpen && (
					<RelateFlowchartControlModel
						isModalOpen={isFlowchartStepControlModalOpen}
						onClickRelateModal={buttonConfig[1].onClick}
						stepName={stepName}
					/>
				)}

				{isFlowchartStepITApplicationSO.isITApplicationModalOpen && (
					<RelateFlowchartITAppSOModal
						isModalOpen={isFlowchartStepITApplicationSO.isITApplicationModalOpen}
						onClickRelateModal={buttonConfig[2].onClick}
						isITApplication
						stepName={stepName}
					/>
				)}
				{isFlowchartStepITApplicationSO.isITSOOpen && (
					<RelateFlowchartITAppSOModal
						isModalOpen={isFlowchartStepITApplicationSO.isITSOOpen}
						onClickRelateModal={buttonConfig[3].onClick}
						isITApplication={false}
						stepName={stepName}
					/>
				)}
			</section>
		</StyledStepTabContainer>
	);
};

export default StepTabSection;

const NameCellRenderer = (props) => {
	return (
		<>
			<EllipsesControl
				noOfLines={1}
				content={props.data[props.colDef.field]}
				tooltip={props.data[props.colDef.field]}
			/>
		</>
	);
};

const ellipsisHeaderComponent = ({label}) => {
	return <EllipsesControl noOfLines={1} content={label} tooltip={label} />;
};

const StyledStepTabContainer = styled.section`
	.steptab {
		width: 100%;
		display: block;
	}

	.relate-wcgw {
		padding: var(--px-16) 0 var(--px-16) 0;
		font-size: var(--px-14);
		font-weight: 400;
		color: var(--blue-600);
	}

	.pagination-control {
		display: flex;
		margin-top: var(--px-20);
	}

	.parentwrapper{
		display: grid;
	}

	.AGGridWrapperSection {
		.ag-root-wrapper {
			border-radius: var(--px-8);
		}
		height: calc(var(--px-240) + var(--px-3))!important;
		.motif-progress-loader-circular{
			width: var(--px-32);
			height: var(--px-32);
		}

		//for 125% resolution
		@media screen and (max-width: 1600px),
			screen and (min-height: 1020px) {
			height: calc(var(--px-265) + var(--px-4))!important;
		}
		//for 150% resolution
		@media screen and (max-width: 1280px),
			screen and (max-height: 720px) {
			height: calc(var(--px-300) + var(--px-3))!important;
		}

		.ag-header-cell {
			.ag-header-cell-comp-wrapper{
				font-size: var(--px-14);
				font-weight: 400;
				color: var(--neutrals-900);
			}
		}

		.ag-body{
			.ag-cell{
				font-size: var(--px-14);
				font-weight: 300;
				color: var(--neutrals-900);
			}
		}
	}

	.norow{
		display: flex;
		padding: var(--px-16) 0 var(--px-32) 0;
		height: calc(var(--px-300) + var(--px-3))!important;

		.no-rows-overlay {
			font-size: var(--px-14);
			font-weight: 300;
			color: var(--neutrals-700)
			display: flex;
			align-items: center;
			text-align: center;
			display: flex;
			margin: 0 auto;

			.motif-button{
				font-size: var(--px-14);
				font-weight: 400;
				color: var(--blue-600);
				line-height: normal;
			}
		}

		.no-rows-overlay span {
			margin: 0 var(--px-4);
		}

		.table-button-click {
			pointer-events: all;
		}
	}
`;
